module.exports = __webpack_public_path__ + "static/media/img_payment.4d1ef6b8.png";